export default __webpack_public_path__ + "static/media/fire.71ff699d.svg";